import {useState} from 'react';
import {message} from 'antd';
import {useMutation} from 'react-apollo';
import {cleanGraphQLErrorMsg} from 'common/util';
import DeleteEntity from 'Mutations/DeleteEntity';
import {getCargoDeleteDisabledReason} from './delete-cargo';

export interface CargoDeletionTarget {
    _id: string;
    name?: string;
    currentCarrierID?: unknown;
    tpID?: {
        _id?: string | null;
    } | null;
}

export default function useDeleteCargo(refetch: () => Promise<any>) {
    const [deletingCargoID, setDeletingCargoID] = useState<string | null>(null);
    const [deleteCargoEntity, {loading: cargoDeleting}] = useMutation(DeleteEntity);

    async function deleteCargo(cargo: CargoDeletionTarget) {
        const disabledReason = getCargoDeleteDisabledReason(cargo);
        if (disabledReason) {
            message.error(disabledReason);
            return;
        }

        const tpID = cargo.tpID?._id;
        if (!tpID) {
            message.error('Failed to delete cargo because its transporter could not be determined.');
            return;
        }

        setDeletingCargoID(cargo._id);
        try {
            await deleteCargoEntity({
                variables: {
                    _id: cargo._id,
                    tpID
                }
            });
            message.success('Deleted cargo successfully');
            try {
                await refetch();
            } catch {
                message.warning('Cargo was deleted, but the cargo list could not be refreshed.');
            }
        } catch (error) {
            message.error('Failed to delete cargo: ' + cleanGraphQLErrorMsg(error?.message || String(error)));
        } finally {
            setDeletingCargoID(null);
        }
    }

    return {
        cargoDeleting,
        deleteCargo,
        deletingCargoID
    };
}
